module.exports = __webpack_public_path__ + "static/media/TAXI.61c9d168.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/TAXI.jpg
// module id = 1779
// module chunks = 1